document.addEventListener('click',event=>{const button=event.target.closest('[data-cc-photo]');if(!button)return;const gallery=button.closest('.cc-gallery');const photo=button.querySelector('img');const main=gallery.querySelector('.cc-gallery-main img');if(!photo||!main)return;for(const key of ['src','srcset','alt','width','height']){const value=photo.getAttribute(key);if(value!==null)main.setAttribute(key,value);}main.setAttribute('sizes','(max-width: 749px) 100vw, 50vw');const photos=[...gallery.querySelectorAll('[data-cc-photo]')];photos.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));const count=gallery.querySelector('[data-cc-gallery-count]');if(count)count.textContent=String(photos.indexOf(button)+1).padStart(2,'0')+' / '+String(photos.length).padStart(2,'0');});

function stepCuttleGallery(gallery, direction) {
  if (!gallery) return;
  const photos = [...gallery.querySelectorAll('[data-cc-photo]')];
  if (photos.length < 2) return;
  const current = Math.max(0, photos.findIndex(photo => photo.getAttribute('aria-pressed') === 'true'));
  photos[(current + direction + photos.length) % photos.length].click();
}
document.addEventListener('click', event => {
  const arrow = event.target.closest('[data-cc-gallery-direction]');
  if (arrow) stepCuttleGallery(arrow.closest('.cc-gallery'), Number(arrow.dataset.ccGalleryDirection));
});
const cuttleGalleryStarts = new WeakMap();
document.addEventListener('pointerdown', event => {
  const main = event.target.closest('.cc-gallery-main');
  if (!main || !matchMedia('(max-width: 749px)').matches || event.isPrimary === false || event.button !== 0 || event.target.closest('button,a')) return;
  cuttleGalleryStarts.set(main, {id: event.pointerId, x: event.clientX, y: event.clientY});
  main.setPointerCapture(event.pointerId);
});
document.addEventListener('pointerup', event => {
  const main = event.target.closest('.cc-gallery-main');
  const start = main && cuttleGalleryStarts.get(main);
  if (!start || start.id !== event.pointerId) return;
  cuttleGalleryStarts.delete(main);
  const dx = event.clientX - start.x;
  const dy = event.clientY - start.y;
  if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.25) stepCuttleGallery(main.closest('.cc-gallery'), dx < 0 ? 1 : -1);
});
document.addEventListener('pointercancel', event => {
  const main = event.target.closest('.cc-gallery-main');
  if (main && cuttleGalleryStarts.get(main)?.id === event.pointerId) cuttleGalleryStarts.delete(main);
});

function setCuttleMenuOpen(open) {
  document.body.classList.toggle('menu-mobile--open', open);
  document.querySelectorAll('.button-menu .js-menu-mobile').forEach(button => button.setAttribute('aria-expanded', String(open)));
}
// Delegation also works after Shopify re-renders the header in the editor.
document.addEventListener('click', event => {
  const toggle = event.target.closest('.js-menu-mobile');
  if (toggle) {
    event.preventDefault();
    setCuttleMenuOpen(!document.body.classList.contains('menu-mobile--open'));
  } else if (event.target.closest('.menu-mobile__overlay, .menu-mobile__nav a')) {
    setCuttleMenuOpen(false);
  }
});
document.addEventListener("keydown",event=>{if(event.key==="Escape"&&document.body.classList.contains("menu-mobile--open")){setCuttleMenuOpen(false);document.querySelector(".button-menu .js-menu-mobile")?.focus();}});

// Keep the native Newsletter popup, adding keyboard access and an explicit
// announcement-bar entry point even after the first-visit cookie is set.
function initializeCuttleContent() {
  const popup = document.querySelector('.js-newsletter-popup');
  const dialog = popup?.querySelector('[role="dialog"]');
  const success = popup?.querySelector('.js-newsletter-popup-success');
  if (success) {
    popup.querySelector('.title-newsletter').textContent = success.dataset.successHeading;
    const subtitle = popup.querySelector('.text-newsletter');
    if (subtitle) subtitle.hidden = true;
    popup.classList.add('show');
  }
  let previousFocus;
  let wasOpen = false;
  if (popup && dialog) {
    const focusEmail = () => setTimeout(() => {
      if (popup.classList.contains('show')) dialog.querySelector('input[type="email"]')?.focus();
    }, 350);
    const trackVisibility = () => {
      const open = popup.classList.contains('show');
      if (open && !wasOpen) {
        previousFocus = document.activeElement;
        focusEmail();
      } else if (!open && wasOpen) {
        previousFocus?.focus();
      }
      wasOpen = open;
    };
    new MutationObserver(trackVisibility).observe(popup, { attributes: true, attributeFilter: ['class'] });
    trackVisibility();
    document.addEventListener('click', event => {
      const trigger = event.target.closest('a[href="#cuttle-newsletter"]');
      if (trigger) {
        event.preventDefault();
        previousFocus = trigger;
        wasOpen = true;
        popup.classList.add('show');
        focusEmail();
      }
    });
    document.addEventListener('keydown', event => {
      if (!popup.classList.contains('show')) return;
      if (event.key === 'Escape') {
        popup.querySelector('.newsletter-popup__close')?.click();
      } else if (event.key === 'Tab') {
        const controls = [...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(element => !element.disabled && element.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!dialog.contains(document.activeElement)) {
          event.preventDefault(); first?.focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cc-open-details]');
    if (!trigger) return;
    const target = document.getElementById(trigger.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault(); target.open = true;
    target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
    target.querySelector('summary')?.focus({preventScroll:true});
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCuttleContent);
else initializeCuttleContent();

function activateCuttleUsage(tab) {
  const root = tab.closest('[data-cc-usage]');
  root.querySelectorAll('[role="tab"]').forEach(button => {
    const active = button === tab;
    button.setAttribute('aria-selected', String(active));
    button.tabIndex = active ? 0 : -1;
    document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
  });
}
document.addEventListener('click', event => {
  const tab = event.target.closest('[data-cc-usage] [role="tab"]');
  if (tab) activateCuttleUsage(tab);
});
document.addEventListener('keydown', event => {
  const tab = event.target.closest('[data-cc-usage] [role="tab"]');
  if (!tab) return;
  const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
  const index = tabs.indexOf(tab);
  const next = {ArrowRight: (index + 1) % tabs.length, ArrowLeft: (index - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1}[event.key];
  if (next === undefined) return;
  event.preventDefault(); activateCuttleUsage(tabs[next]); tabs[next].focus();
});

document.addEventListener('shopify:section:load', () => {
  if (typeof wpbingo !== 'undefined') wpbingo.slideshow();
  initializeCuttleAutoplay();
});

document.addEventListener('change', event => {
  const selector = event.target.closest('.cc-purchase-form select[name="id"]');
  if (!selector) return;
  const price = selector.closest('form').querySelector('[data-cc-price]');
  const option = selector.selectedOptions[0];
  if (price && option) price.textContent = option.dataset.price;
});

// Reuse the theme's cart refresh without navigating away from the selected size.
document.addEventListener('submit', async event => {
  const form = event.target.closest('.cc-purchase-form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[name="add"]');
  if (button.disabled) return;
  const result = form.parentElement.querySelector('[data-cc-cart-result]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  result.hidden = true;
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    result.dataset.error = 'false';
    result.textContent = 'Added to your cart.';
    if (typeof ShopifyAPI !== 'undefined' && typeof cartUpdateCallback === 'function') {
      ShopifyAPI.getCart(cartUpdateCallback, false);
    } else {
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').catch(() => null);
      if (cartResponse?.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(count => count.textContent = cart.item_count);
      }
    }
  } catch (error) {
    result.dataset.error = 'true';
    result.textContent = error.message || 'Unable to add this item. Please try again.';
  } finally {
    result.hidden = false;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});

const cuttleAutoplayRoots = new WeakSet();
function initializeCuttleAutoplay() {
  document.querySelectorAll('.cc-gallery, [data-cc-usage]').forEach(root => {
    if (cuttleAutoplayRoots.has(root)) return;
    cuttleAutoplayRoots.add(root);
    const control = root.querySelector('[data-cc-autoplay-toggle]');
    if (!control) return;
    const photos = [...root.querySelectorAll('[data-cc-photo]')];
    const steps = [...root.querySelectorAll('[role="tab"]')];
    const gallery = photos.length > 0;
    if ((gallery ? photos.length : steps.length) < 2) { control.hidden = true; return; }
    const pauseLabel = gallery ? 'Pause photos' : 'Pause steps';
    const playLabel = gallery ? 'Play photos' : 'Play steps';
    let paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const updateControl = () => {
      control.setAttribute('aria-pressed', String(paused));
      control.textContent = paused ? playLabel : pauseLabel;
    };
    updateControl();
    control.addEventListener('click', () => { paused = !paused; updateControl(); });
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); return; }
      const rect = root.getBoundingClientRect();
      const mouseHover = matchMedia('(hover: hover) and (pointer: fine)').matches && root.matches(':hover');
      if (paused || document.hidden || mouseHover || root.querySelector(':focus-visible') || rect.bottom <= 0 || rect.top >= innerHeight) return;
      if (gallery) {
        const index = photos.findIndex(photo => photo.getAttribute('aria-pressed') === 'true');
        photos[(index + 1) % photos.length].click();
      } else {
        const index = steps.findIndex(step => step.getAttribute('aria-selected') === 'true');
        activateCuttleUsage(steps[(index + 1) % steps.length]);
      }
    }, gallery ? 5000 : 8000);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCuttleAutoplay);
else initializeCuttleAutoplay();
